import React from 'react';
import { Button, Typography } from 'antd';
import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { Trans } from 'react-i18next';
import { ReactComponent as QuickRepliesDeleteIcon } from '../../../../../../assets/icons/deleteIcon/deleteIcon.svg';
import QuickReplyPreview from '../../../../../QuickReplies/components/shared/QuickReplyPreview';
import { StaticQuickReplyPreview } from '../QuickRepliesField/QuickRepliesField';
import { useStore } from '../../../../../../store/rootStore';
import styles from './DeleteConfirmation.module.scss';
const { Text } = Typography;
const DeleteConfirmation = ({ reply, deleteReply, onCancel, loading }) => {
    const { activeChatStore } = useStore();
    return (React.createElement("div", { className: styles.addReplyWrapper },
        React.createElement("div", { className: styles.titleRepliesDeleteConfirmation },
            React.createElement("div", { className: styles.redDeleteIcon },
                React.createElement(Icon, { component: QuickRepliesDeleteIcon })),
            React.createElement(Text, { className: styles.repliesAddTitleText },
                React.createElement(Trans, { i18nKey: "sureDeleteReply" }))),
        React.createElement("div", { className: styles.repliesTextEditorWrapper },
            React.createElement("div", { className: styles.deleteReplyHolder }, activeChatStore.chat ? (React.createElement(QuickReplyPreview, { quickReply: reply, className: styles.quickReplyMessage, messageClassName: classNames(styles.messageItem, styles.quickReplyMessagePreview) })) : (React.createElement(StaticQuickReplyPreview, { reply: reply })))),
        React.createElement("div", { className: styles.addReplyBottom },
            React.createElement(Button, { className: classNames('big', styles.addReplyCancelButton), onClick: onCancel, disabled: loading },
                React.createElement(Text, null,
                    React.createElement(Trans, { i18nKey: "cancel" }))),
            React.createElement(Button, { className: classNames('big', styles.addReplyDeleteButton), type: "primary", danger: true, onClick: () => deleteReply(), loading: loading },
                React.createElement(Text, null,
                    React.createElement(Trans, { i18nKey: "deleteSubmit" }))))));
};
export default DeleteConfirmation;
